import { injectEntity } from "../../../../../../../common/store/base/injectEntity";
import { injectEntityList } from "../../../../../../../common/store/base/injectEntityList";
import { IContentImportUI, IFileForImport } from "./IContentImportUI";

export class ContentImportUI implements IContentImportUI {
    public unitsForImport = injectEntityList<IFileForImport>([]);
    public dropzoneErrors = injectEntityList<string>([]);
    public withDependencies = injectEntity<boolean>(true);
    public isPasswordDialogOpen = injectEntity<boolean>(false);
    public importPassword = injectEntity<string>("");
    public passwordError = injectEntity<string | null>(null);
    public isImporting = injectEntity<boolean>(false);
    public importProgress = injectEntity<{ current: number; total: number }>({
      current: 0,
      total: 0,
    });
    public importResults = injectEntityList<{ filename: string; success: boolean; message: string }>([]);
    public isPasswordVisible = injectEntity<boolean>(false);

}